<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Logging out</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <p>You are now logged out of ICT Plus</p>
              <p>You may close this browser window or log in again using the button below</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" to="/login">Sign in</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
  import {mapActions} from 'vuex';
  export default {
    name: "Logout",
    mounted() {
      this.clearAllFilters();
      sessionStorage.clear();
    },
    methods: {
      ...mapActions(['clearAllFilters']),
    },
  }
</script>

<style scoped>

</style>
